export default class UsersData {

	static initial() {
		this.editData();
		this.subscribes();
	}

	static editData() {

		let $initialAddress = $('#contact_info_form').validate({
				highlight: function(element) {
					$(element).addClass("valid-error").removeClass("success");
				},
				unhighlight: function(element) {
					$(element).removeClass("valid-error").addClass("success");
				},
				errorPlacement: function(error, element) {
					if (element.attr("name") == "politic" ) {
					} else {
						error.insertAfter(element);
					}
				},
				rules: {
					politic: "required"
				},
				submitHandler: function(form){
					let action = $(form).attr('action');
					let	formData = new FormData($(form)[0]);

					$(form).find('button[type="submit"]').prop('disabled', true);
					$.ajax({
						type: "POST",
						url: action,
						processData: false,
						contentType: false,
						data: formData,
						dataType: "json",
					}).then(function (resp) {

						if(resp.success) {

							$('#xhr-th-text').html(resp.message);
							$(document).trigger('trigger.show.popup', ['infoMassage']);

						} else {

							$('#xhr-th-text').html('Виникла помилка');
							$(document).trigger('trigger.show.popup', ['infoMassage']);

						}

					}).fail(function (jqXHR, textStatus, errorThrown) {

						$('#xhr-th-text').html('Виникла помилка');
						$(document).trigger('trigger.show.popup', ['infoMassage']);

					}).always(function () {

						$(form).find('button[type="submit"]').prop('disabled', false);

					});
				}
		});

	}

	static subscribes() {
		let $initialSub = $('#manageSubscriptions-form').validate({
			highlight: function(element) {
				$(element).addClass("valid-error").removeClass("success");
			},
			unhighlight: function(element) {
				$(element).removeClass("valid-error").addClass("success");
			},
			submitHandler: function(form){
				let action = $(form).attr('action'),
					formData = new FormData($(form)[0]);

				$(form).find('button[type="submit"]').prop('disabled', true);
				$.ajax({
					type: "POST",
					url: action,
					processData: false,
					contentType: false,
					data: formData,
					dataType: "json",
				}).then(function (resp) {
					if(resp.success) {
						$(form).closest('.wrap_popup').fadeOut(function () {
							let $blShow =  $('#infoMassage');
							$blShow.find('#xhr-th-text').html(resp.message);
							$blShow.fadeIn();
						});
					} else {
						alert(resp.message);
					}
				}).fail(function (jqXHR, textStatus, errorThrown) {
					if(jqXHR.status === 422) {
						let errorObj = {};
						if(jqXHR.responseJSON.errors) {
							const objErrors = jqXHR.responseJSON.errors;
							for (let property in objErrors) {
								errorObj[property] = objErrors[property].join(',');
							}
						}
						$initialSub.showErrors(errorObj);
					}
				}).always(function () {
					$(form).find('button[type="submit"]').prop('disabled', false);
				});
			}
		});
	}
}
